import { render, staticRenderFns } from "./updatePasswordModal.vue?vue&type=template&id=38e226c2&scoped=true&"
import script from "./updatePasswordModal.vue?vue&type=script&lang=js&"
export * from "./updatePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePasswordModal.vue?vue&type=style&index=0&id=38e226c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e226c2",
  null
  
)

export default component.exports